import React from 'react'
import './CSS/Contactus.css'

function Contactus() {
  return (
    <body class="contactus-body" >
    <section class="contactus-container">
        <div>
            <h1 class="contactus-title">Get in touch</h1>
            <form class="contact-form row">
            <div class="form-field col x-50">
                <input id="name" class="contactus-input-text js-input" type="text" required />
                <label class="contactus-label" for="name">Name</label>
            </div>
            <div class="form-field col x-50">
                <input id="email" class="contactus-input-text js-input" type="email" required />
                <label class="contactus-label" for="email">Email *</label>
            </div>
            <div class="form-field col x-100">
                <input id="message" class="contactus-input-text js-input" type="text" required />
                <label class="contactus-label" for="message">Leave us a message...</label>
            </div>
            <div class="form-field col x-100 align-center">
                <input class="contactus-submit-btn" type="submit" value="Submit"/>
            </div>
            </form>
        </div>
     </section>
</body>
  )
}

export default Contactus